module.exports = __webpack_public_path__ + "img/recruit_4.3cd034a9.png";